import { render, staticRenderFns } from "./selfListDetail.vue?vue&type=template&id=b649d7ac&scoped=true&"
import script from "./selfListDetail.vue?vue&type=script&lang=js&"
export * from "./selfListDetail.vue?vue&type=script&lang=js&"
import style0 from "./selfListDetail.vue?vue&type=style&index=0&id=b649d7ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b649d7ac",
  null
  
)

export default component.exports